module.exports = __webpack_public_path__ + "static/media/008.8eca5ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/008.jpg
// module id = 552
// module chunks = 0